import React, {useCallback, useMemo} from 'react';
import {connect} from "react-redux";
import {THUMBNAIL_SIZES} from "../../../../../../../misc/utils";
import LookFeaturePrice from "../../../../../../look/lookNavigation/lookMain/lookListFeature/lookFeaturePrice";
import FeatureName from "../../../../../../visComponents/featureName";
import FeatureDescription from "../../../../../../visComponents/featureDescription";
import {featureThumbnailUrl} from "../../../../../../../misc/helpers";
import CheckIcon from "@mui/icons-material/Check";
import {mobileDragHelper} from "../../../../canvas/helpers/mobileDragHelper";
import {useMobileDrag} from "../../../../../hocs/useMobileDrag";
import {createApplianceFromFeature} from "../../../../../helpers/featureHelper";
import {getMousePositionOnField} from "../../../../../helpers/sqftHelper";
import {createCustomDragImage} from "../../../../canvas/helpers/desktopDragHelper";
import {
  getDepthFromDbFeature,
  getRelatedFeatureMetadata,
  getWidthFromDbFeature
} from "../../../../../helpers/sqft3dArHelper";
import sqftConfig from "../../../../canvas/store/sqftConfig";

const FeaturesRow = (props) => {
  const { feature, index, style, parentFeature, activeItemIndex, setActiveItemIndex, itemClickCallback } = props;
  const { lookViewType, isMobile } = props;
  const isActive = activeItemIndex === index;

  const className = useMemo(() => {
    return "lm-feature lm-feature--type-" + lookViewType + (isActive ? " lm-feature--active" : "");
  }, [isActive, lookViewType]);

  const imageUrl = useMemo(() => featureThumbnailUrl(feature, THUMBNAIL_SIZES.medium), [feature]);

  // Handle drop for your custom logic
  const handleDrop = useCallback((dropInfo) => {
    console.log('Feature dropped:', dropInfo);

    // Or use the helper with custom handling
    if (mobileDragHelper.isDropOnCanvas(dropInfo.x, dropInfo.y)) {
      const coords = mobileDragHelper.getCanvasCoordinates(dropInfo.x, dropInfo.y);
      const mousePosOnFiled = getMousePositionOnField(coords.x, coords.y);
      const movableImage = createApplianceFromFeature(feature);
      movableImage.setPosition(mousePosOnFiled);
      console.log('Dropped on canvas at:', coords);
    }
  }, [feature]);

  // Handle tap
  const handleTap = useCallback((tapInfo) => {
    setActiveItemIndex(index);
    itemClickCallback(tapInfo.event, feature, parentFeature);
  }, [index, feature, parentFeature, setActiveItemIndex, itemClickCallback]);


  /**
   * this date is used in cabinet workspace to create appliances
   * @type {{partId: *, featureName: *, featureId: *}}
   */
  const dragData = useMemo(() => ({
    partId: feature.partId,
    featureId: feature.dbFeature.id,
    featureName: feature.getFeatureName(),
  }), [feature]);

  // Use mobile drag hook
  const { isDragging, elementRef, handlers, dragStyle } = useMobileDrag({
    onDrop: handleDrop,
    onTap: handleTap,
    dragData: dragData,
    dragImageUrl: imageUrl,
    dragText: feature.getFeatureName(),
    enabled: isMobile
  });

  void isDragging;

  // Desktop handlers
  const handleButtonClick = useCallback((e) => {
    if (!isMobile) {
      e.preventDefault();
      setActiveItemIndex(index);
      itemClickCallback(e, feature, parentFeature);
    }
  }, [index, feature, parentFeature, setActiveItemIndex, itemClickCallback, isMobile]);

  const handleDragStart = useCallback((e) => {
    e.dataTransfer.setData('featureId', JSON.stringify(feature.dbFeature.id));
    e.dataTransfer.setData('featureName', feature.getFeatureName());
    e.dataTransfer.setData('partId', feature.partId || '');

    const thirdPartyAR3DMetaData = getRelatedFeatureMetadata(feature, parentFeature);
    const width = getWidthFromDbFeature(feature.dbFeature, thirdPartyAR3DMetaData);
    const depth = getDepthFromDbFeature(feature.dbFeature, thirdPartyAR3DMetaData);
    const title = 'W:' + width + ' D:' + depth;

    const preview = createCustomDragImage(imageUrl, title, width * sqftConfig.scale, depth * sqftConfig.scale);

    // Set drag image with offset (0, 0) to position at cursor
    e.dataTransfer.setDragImage(preview.element, 0, 0);
  }, [feature, parentFeature, imageUrl]);

  return (
    <div
      className={className}
      ref={elementRef}
      style={{
        ...style,
        ...(isMobile ? dragStyle : {})
      }}
      key={index}
      draggable={!isMobile}
      onDragStart={!isMobile ? handleDragStart : undefined}
      {...(isMobile ? handlers : {})}
      onClick={handleButtonClick}
    >
      <div className={"lm-feature__thumbnail lm-feature__thumbnail--full "}>
        {isActive ? (
          <div className="lm-feature__checkmark">
            <CheckIcon fontSize="small"/>
          </div>
        ) : null}
        {imageUrl ? <img src={imageUrl} className="feature-thumbnail__image" alt="" /> : null}
      </div>
      <div className={"lm-feature__content"}>
        <div className="lm-feature__content-name">
          {feature.getFeatureName()}
        </div>
        <div className="lm-feature__content-description">
          <FeatureDescription feature={feature} textLength={80}/>
        </div>
        <div className="lm-feature__content-price">
          <LookFeaturePrice showPriceAlways={true} lookFeature={feature} listPage={true} className="lm-feature__content-price-text"/>
          {lookViewType === 4 ? <FeatureName feature={feature} useCollectionName={true}/> : null}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => {
  const { menuOpened } = store.sqftMenuState;
  const { visualizersLoaded, windowHeight, isMobile } = store.serverState;
  const { lookViewType } = store.lookState;

  return {
    menuOpened,
    windowHeight,
    isMobile,
    lookViewType,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

export default connect(mapStateToProps)(FeaturesRow);
